module.exports = __webpack_public_path__ + "static/media/userActive.d6a0746e.svg";